@if (!isAccessFlagLoading() && !isUrlVerified()) {
  <app-url-verification
    [hasAccess]="isAccessEnabled()"
    [noAccessMessage]="featureFlagErrorText() | translate"
    [tenantApiBaseUrl]="tenantService.BASE_URL"
    (successfulVerificationEvent)="onSuccessfulVerification()"
    (mustSignOutEvent)="signOut()"
  >
  </app-url-verification>
} @else {
  @if (!isAccessFlagLoading() && !isLoading() && user()) {
    <div class="container">
      <app-banner
        [user]="user()"
        [isAccessITPAdmin]="isAccessITPAdmin()"
        [title]="'intelligentTranscriptProcessing' | translate"
        [hasWebCapture]="hasWebCaptureAccess() && webCaptureFeatureFlag()"
        [hasTranscriptProcessing]="transcriptProcessingFlag() && hasItpAccess()"
      >
      </app-banner>

      <div class="router-container">
        <router-outlet></router-outlet>
      </div>
    </div>
  }
}
